import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexPagenation',
  setup(__props) {

const simplePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/simplePagination.vue"))
const disabledPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/disabledPagination.vue"))
const iconsPagenation = defineAsyncComponent(() => import("@/components/theme/advance/pagination/iconsPagenation.vue"))
const roundedPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/roundedPagination.vue"))
const alignmentsPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/alignmentsPagination.vue"))
const sizingPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/sizingPagination.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Pagination"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(simplePagination)),
        _createVNode(_unref(disabledPagination)),
        _createVNode(_unref(iconsPagenation)),
        _createVNode(_unref(roundedPagination)),
        _createVNode(_unref(alignmentsPagination)),
        _createVNode(_unref(sizingPagination))
      ])
    ])
  ], 64))
}
}

})